import { render, staticRenderFns } from "./custom-breadcrumb.vue?vue&type=template&id=1e2684c1"
import script from "./custom-breadcrumb.vue?vue&type=script&lang=js"
export * from "./custom-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./custom-breadcrumb.vue?vue&type=style&index=0&id=1e2684c1&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2684c1')) {
      api.createRecord('1e2684c1', component.options)
    } else {
      api.reload('1e2684c1', component.options)
    }
    module.hot.accept("./custom-breadcrumb.vue?vue&type=template&id=1e2684c1", function () {
      api.rerender('1e2684c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "custom-breadcrumb.vue"
export default component.exports